import { VanillaSliderForm } from "./vanilla-slider-form";
import { VanillaSliderHandler } from "./vanilla-slider-handler";

export class VanillaSliderListener {
    private readonly form: VanillaSliderForm;

    private readonly handler: VanillaSliderHandler;

    public constructor(form: VanillaSliderForm, handler: VanillaSliderHandler) {
        this.form = form;
        this.handler = handler;
    }

    public register(): void {
        const mq = globalThis.matchMedia?.("(max-width: 768px)");
        if (!mq) return;
        mq.addEventListener("change", () => {
            this.handler.onMobileChange(mq.matches);
        });
    }
}
